<div class="scrn">
  <div class="abs_center out">
    <div class="title">
      {{title}}
    </div>


    <img class="close" src="assets/images/close.svg" alt="close" kzLib (click)="cancel()">

    <input kzInput class="in" type="name" placeholder="First Name" name="" value="" [(ngModel)]="first_name" (ngModelChange)="checkReady()">
    <input kzInput class="in" type="name" placeholder="Last Name" name="" value="" [(ngModel)]="last_name" (ngModelChange)="checkReady()">


    <div class="invite">
      <div class="abs_center invite_btn" [ngClass]="{ready:bReady}" color="#fff" kzLib (click)="save()">
        <div class="itx">
          {{btn_lbl}}
        </div>
      </div>
    </div>
    <img src="assets/images/delete.svg" class="del_pat" kzLib (click)="deletePatient()">
  </div>
</div>
